<template>
  <div class="search-box">
    <div class="search-bar">
      <div v-for="item in currentSearchList" :key="item.name + '-' + resetKey">
        <!-- 数字输入框 - 使用 van-field -->
        <van-field
          v-if="item.type === 'Input' && item.inputType"
          v-model="formModel[item.name]"
          :placeholder="item.label"
          :type="item.inputType"
          clearable
          :disabled="get(searchConfig, item.name + '.isDisabled', false)"
        />
        <!-- 普通输入框 - 使用 cube-input -->
        <cube-input
          v-else-if="item.type === 'Input'"
          :clearable="!item.isNotClearable"
          v-model="formModel[item.name]"
          :placeholder="item.label"
          :disabled="get(searchConfig, item.name + '.isDisabled', false)"
        ></cube-input>
        <wmq-select
          :clearable="!item.isNotClearable"
          v-if="item.type === 'Select'"
          :value="formModel[item.name]"
          @updateValue="(res) => handleSelectChange(item, res)"
          :placeholder="item.label"
          :options="item.options"
          :disabled="get(searchConfig, item.name + '.isDisabled', false)"
          :isSearch="item.isSearch || false"
          @remoteHandle="(value) => handleRemoteSearch(item, value)"
        ></wmq-select>
        <wmq-date
          v-if="item.type === 'Date'"
          :value="formModel[item.name]"
          :placeholder="item.label"
          type="date"
          valueFormatter="YYYY-MM-DD"
          @updateValue="(res) => (formModel[item.name] = res)"
          :clearable="!item.isNotClearable"
        ></wmq-date>
        <wmq-date-range-picker
          :clearable="!item.isNotClearable"
          v-if="item.type === 'MonthRange'"
          v-show="item.show ? item.show(formModel) : true"
          :value="formModel[item.name]"
          :placeholder="item.label"
          @updateValue="(res) => (formModel[item.name] = res)"
          valueFormatter="YYYY-MM"
          :disabled="get(searchConfig, item.name + '.isDisabled', false)"
        ></wmq-date-range-picker>
        <wmq-date-range-picker
          :clearable="!item.isNotClearable"
          v-if="item.type === 'DateRange'"
          v-show="item.show ? item.show(formModel) : true"
          :value="formModel[item.name]"
          :placeholder="item.label"
          type="date"
          @updateValue="(res) => (formModel[item.name] = res)"
          :disabled="get(searchConfig, item.name + '.isDisabled', false)"
        ></wmq-date-range-picker>
        <wmq-date-range-picker
          :clearable="!item.isNotClearable"
          v-if="item.type === 'DateTimeRange'"
          :value="formModel[item.name]"
          :placeholder="item.label"
          type="datetime"
          valueFormatter="YYYY-MM-DD HH:mm:ss"
          @updateValue="(res) => (formModel[item.name] = res)"
          :disabled="get(searchConfig, item.name + '.isDisabled', false)"
        ></wmq-date-range-picker>
        <wmq-cascade
          :ref="item.name"
          :clearable="!item.isNotClearable"
          v-if="item.type === 'Cascader'"
          :value="formModel[item.name]"
          :placeholder="item.label"
          :optionSource="item.optionSource"
          @updateValue="(res) => (formModel[item.name] = res)"
          :disabled="get(searchConfig, item.name + '.isDisabled', false)"
        ></wmq-cascade>
      </div>
    </div>
    <div :class="buttonClasses" style="display: flex;" class="search-group">
      <cube-button @click="search" style="margin: 10px">查询</cube-button>
      <cube-button @click="reset" style="margin: 10px">重置</cube-button>
    </div>
  </div>
</template>

<script>
import WmqDateRangePicker from './WmqDateRangePicker'
import WmqDate from './WmqDate'
import WmqCascade from './WmqCascade'
import WmqSelect from './WmqSelect'
import { isEmpty, map, cloneDeep, get } from 'lodash'
import request from '@/utils/request'
export default {
  name: 'SearchBox',
  components: { WmqDateRangePicker, WmqDate, WmqCascade, WmqSelect },
  props: {
    searchList: {
      type: Array,
      default() {
        return []
      }
    },
    searchConfig: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      formModel: {},
      currentSearchList: [],
      buttonClasses: 'default-btn-mode',
      resetKey: 0
    }
  },
  created() {
    this.checkOrientation() // 创建组件时立即检查一次
    window.addEventListener('resize', this.checkOrientation) // 监听窗口大小变化
  },

  mounted() {
    this.init()
  },
  watch: {
    searchList: {
      deep: true,
      handler(newList) {
        if (newList.length > 0) {
          this.syncSearchList(newList)
        }
      }
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.checkOrientation) // 移除监听器
  },
  methods: {
    get,
    /**
       *  监听屏幕旋转
       */
    checkOrientation() {
      const orientation = window.matchMedia('(orientation: landscape)')

      if (orientation.matches) {
        this.buttonClasses = 'landscape-btn-mode'
      } else {
        this.buttonClasses = 'default-btn-mode'
      }
    },
    initForm() {
      const list = this.currentSearchList.length ? this.currentSearchList : this.searchList
      const newModel = {}

      list.forEach(item => {
        if (item.matchType === 'In') {
          newModel[item.name] = []
        } else {
          newModel[item.name] = undefined
        }

        const config = get(this.searchConfig, item.name)
        if (config && config.defaultValue !== undefined) {
          newModel[item.name] = config.defaultValue
        }
      })

      if (newModel.dataFlowType === 'inventory') {
        const inventoryDate = get(this.searchConfig, 'beginTime.inventoryDefaultValue')
        if (inventoryDate !== undefined) {
          newModel.beginTime = inventoryDate
          newModel.endTime = inventoryDate
        }
      } else if (list.some(item => item.name === 'endTime')) {
        const endDefault = get(this.searchConfig, 'endTime.defaultValue')
        if (endDefault !== undefined) {
          newModel.endTime = endDefault
        }
      }

      this.formModel = newModel
    },
    init() {
      this.initForm()
      this.syncSearchList(this.searchList)
    },
    syncSearchList(sourceList) {
      const searchList = cloneDeep(sourceList)
      searchList.forEach(item => {
        const config = get(this.searchConfig, item.name, undefined)
        if (config?.isNotClearable) {
          item.isNotClearable = true
        }
        if (!isEmpty(item.options)) {
          item.options = map(item.options, optionItem => ({
            value: optionItem.value ?? optionItem.code,
            text: optionItem.text ?? optionItem.label
          }))
        }
        if (!isEmpty(item.optionSource) && item.type !== 'Cascader') {
          request({
            url: item.optionSource.path,
            method: 'get'
          }).then(res => {
            item.options = map(res.data.items, optionItem => {
              return {
                value: optionItem.code,
                text: optionItem.label
              }
            })
          })
        }
      })

      this.currentSearchList = searchList
    },
    search() {
      this.$emit('search', this.formModel)
    },
    handleSelectChange(item, value) {
      this.$set(this.formModel, item.name, value)
      if (typeof item.onChange === 'function') {
        item.onChange(value, this.formModel)
      }
    },
    reset() {
      this.initForm()
      this.resetKey += 1
      this.$emit('reset', { ...this.formModel })
    },
    // 处理远程搜索
    handleRemoteSearch(item, value) {
      // 如果配置了远程搜索函数，调用它
      if (item.remoteSearch && typeof item.remoteSearch === 'function') {
        item.remoteSearch(value).then(options => {
          const normalizedOptions = map(options, optionItem => ({
            value: optionItem.value ?? optionItem.code,
            text: optionItem.text ?? optionItem.label
          }))
          this.$set(item, 'options', normalizedOptions)
          const currentItem = this.currentSearchList.find(i => i.name === item.name)
          if (currentItem) {
            this.$set(currentItem, 'options', normalizedOptions)
          }
        }).catch(error => {
          console.error('远程搜索失败:', error)
        })
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/theme-variables.styl'

.search-box
  height 100%
  overflow-y auto
  overflow-x hidden
  background $page-bg-gradient
  padding $spacing-page
  overscroll-behavior: contain
  -webkit-overflow-scrolling: touch
  touch-action: pan-y

.search-bar
  background $card-bg
  border-radius $border-radius-item
  padding $spacing-page
  margin-bottom 200px
  box-shadow 0 2px 12px rgba(100, 116, 139, 0.08)

  > div
    margin-bottom 20px
    &:last-child
      margin-bottom 0

.search-group
  position absolute
  bottom 0
  left 0
  width 100%
  background $card-bg
  padding 20px
  box-shadow 0 -2px 12px rgba(100, 116, 139, 0.08)
  display flex
  gap 20px

  .cube-btn
    flex 1
    height 80px
    border-radius $border-radius-small
    font-size 28px
    font-weight 500
    padding inherit
    &:last-child
      background $card-bg
      border 1px solid $border-normal
      color $text-primary

    &:first-child
      background $primary-blue
      border none
      color #fff

.landscape-btn-mode
  // 横屏模式：基础间距 + 安全区域
  padding-bottom calc(20px + env(safe-area-inset-bottom))

.default-btn-mode
  // 竖屏模式：基础间距 + 安全区域
  // 不再需要 190px 的固定补偿值
  padding-bottom calc(20px + env(safe-area-inset-bottom))

// cube-input placeholder 颜色
::v-deep .cube-input
  input
    &::placeholder
      color #64748b
      font-size 28px
    color #1e293b
    font-size 28px

// van-field 样式调整
::v-deep .van-field
  background-color #fff
  border 1px solid #eee
  border-radius 0
  padding 0 10px
  height 40Px
  line-height 40Px

  .van-field__control
    color #1e293b
    font-size 14Px

    &::placeholder
      color #64748b
      font-size 14Px
</style>
